// src/data/heroSlides.js

import TomSawyerBanner from "../assets/HeroBannerPlaceholder.png";
import DraculaBanner from "../assets/Dracula-Banner.png";
import ToTheLighthouseBanner from "../assets/To-the-Lighthouse.png";

const heroSlides = [
  {
    id: 'tom-sawyer',
    title: 'The Adventures of Tom Sawyer',
    subtitle: 'A timeless tale of childhood, mischief, and imagination.',
    image: TomSawyerBanner,  // your final hero image path
    primaryBtn: 'Start Reading',
    secondaryBtn: 'Details',
  },
  {
    id: 'dracula',
    title: 'Dracula',
    subtitle: 'A gothic horror classic that defined the vampire myth by Bram Stoker.',
    image: DraculaBanner,
    primaryBtn: 'Start Reading',
    secondaryBtn: 'Details',
  },
  {
    id: 'to-the-lighthouse',
    title: 'To the Lighthouse',
    subtitle: 'A masterpiece of introspection and family by Virginia Woolf.',
    image: ToTheLighthouseBanner,
    primaryBtn: 'Start Reading',
    secondaryBtn: 'Details',
  },
];

export default heroSlides;
